import type { AdditionalProduct, SlotAvailable, SlotAvailablityDTO } from '../types/courses'

export const useCoursesService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/api/courses`

  return {
    getCourseAdditionalProducts(courseId: number) {
      return fetchJson<FetchResult<AdditionalProduct[]>>(
        'GET', `${BASE_URL}/${courseId}/additional-products`,
      )
    },
    postCourseAvailabilities(courseId: number, dto: SlotAvailablityDTO) {
      return fetchJson<FetchResult<SlotAvailable[]>, typeof dto>(
        'POST', `${BASE_URL}/${courseId}/availabilities`, dto,
      )
    },
  }
}
